var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardGraph',{attrs:{"icons":_vm.icons,"title":_vm.title,"chart_type":_vm.chart_type,"chart_handle":_vm.chart_layout,"load_url":_vm.load_url,"options":_vm.options,"options_text":_vm.options_text}})}
var staticRenderFns = []

export { render, staticRenderFns }